import {
  always, curry, equals, path, when,
} from 'ramda';

const baseQuery = { fetchPolicy: 'no-cache' };

const getNameOfQuery = path(['definitions', 0, 'selectionSet', 'selections', 0, 'name', 'value']);

const getOperationNameFromQuery = path(['definitions', 0, 'operation']);

const getQueryMethodForOperation = when(equals('mutation'), always('mutate'));

export default curry(async (query, client, variables) => {
  const queryName = getNameOfQuery(query);
  const queryOperation = getOperationNameFromQuery(query);
  const queryMethod = getQueryMethodForOperation(queryOperation);

  const result = await client[queryMethod]({
    ...baseQuery,
    [queryOperation]: query,
    variables,
  });

  return path(['data', queryName], result);
});
